import type { ConfigProviderProps } from 'naive-ui'
import { createDiscreteApi, darkTheme, lightTheme, zhCN } from 'naive-ui'
import { computed, ref } from 'vue'

// 1. 定义主题
export const theme = ref<'light' | 'dark'>('light')

// 2. 配置ConfigProviderProps
const configProviderPropsRef = computed<ConfigProviderProps>(() => ({
  locale: zhCN,
  theme: theme.value === 'light' ? lightTheme : darkTheme,
  themeOverrides: {
    common: {
      primaryColor: '#2678FF',
      primaryColorHover: '#2678FF',
      successColor: '#47C93A',
      warningColor: '#FF7D00',
      errorColor: '#F53F3F',
      infoColor: '#86909C',
      borderRadius: '4px',
      fontFamily: "'PingFang SC', 'Microsoft YaHei', sans-serif"
    }
  }
}))

// 3. 创建唯一的离散API实例
const { message, dialog, loadingBar, notification, modal } = createDiscreteApi(
  ['message', 'dialog', 'loadingBar', 'notification', 'modal'],
  { configProviderProps: configProviderPropsRef }
)

// 4. 核心：挂载到window全局对象（关键一步！）
// 类型声明（TS项目必加，避免ts报错）
declare global {
  interface Window {
    message: typeof message
    dialog: typeof dialog
    loadingBar: typeof loadingBar
    notification: typeof notification
    modal: typeof modal
  }
}
// 挂载到window
window.message = message
window.dialog = dialog
window.loadingBar = loadingBar
window.notification = notification
window.modal = modal

// 5. 主题切换方法
export function toggleTheme() {
  theme.value = theme.value === 'light' ? 'dark' : 'light'
}

// 导出（可选，留作备用）
export { dialog, loadingBar, message, modal, notification }
